import graphqlClient from '~/graphql/graphqlClient';
import {
  MutationCreateStripePaymentIntentArgs,
  StripePaymentResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation CreateStripePaymentIntent($playerId: String!, $purchaseSelectionId: String!, $paymentMethodId: String!, $platform: String!) {
  createStripePaymentIntent(playerId: $playerId, purchaseSelectionId: $purchaseSelectionId, paymentMethodId: $paymentMethodId, platform: $platform) {
    status
    currency1
    purchaseSelectionId
    chargeAmount
    message
  }
}
`;

export default async function mutationCreateStripePaymentIntent(
  args: MutationCreateStripePaymentIntentArgs
) {
  return await graphqlClient.request<StripePaymentResult>(
    'createStripePaymentIntent',
    mutation,
    args
  );
}
